<template>
  <div class="dynamic-tables">
    <h2 class="page-title">Permohonan Berusaha</h2>
    <Widget customHeader>
      <div>
        <table id="example" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nomor Pemohon</th>
              <th>Instansi Pemohon</th>
              <th>Jenis Kegiatan</th>
              <th>Provinsi</th>

              <th>Tgl. Permohonan</th>
              <th>Status Permohonan</th>
              <th>Keterangan Status</th>
              <th>File</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataPermohonan" :key="index">
              <td></td>
              <td>
                <span class="badge rounded-pill bg-success" style="font-size: 10px; font-weight: normal"
                  v-if="data.nomor_permohonan != null">{{ data.nomor_permohonan }}</span>
                <span class="badge rounded-pill bg-danger" style="
                      font-size: 10px;
                      font-weight: normal;
                      background-color: #ff6e7c !important;
                    " v-else>Belum Ada</span>
              </td>
              <td>{{ data.nama_pemohon }}</td>
              <td>{{ data.jenis_kegiatan }}</td>
              <td>{{ data.provinsi }}</td>

              <td>
                {{ format_date(data.tanggal_pada_permohonan, 'DD MMM YYYY') }}
              </td>
              <!-- <td>
                  <span v-if="data.status_tagihan_iii != null">
                    {{ format_date(data.tanggal_berlaku_hingga_tagihan_iii, "DD MMMM YYYY") }}
                  </span>
                  <span
                    v-else-if="
                      data.status_tagihan_ii != null &&
                      data.status_tagihan_i != null
                    "
                  >
                    {{ format_date(data.tanggal_berlaku_hingga_tagihan_ii, "DD MMMM YYYY") }}
                  </span>
                  <span v-else>
                    {{ format_date(data.tanggal_berlaku_hingga_tagihan_i, "DD MMMM YYYY") }}
                  </span>
                </td> -->
              <td>
                {{ data.status_permohonan }}
              </td>
              <td>
                {{ data.keterangan_status }}
              </td>
              <td>
                <div style="width: 250px" class="row">
                  <div class="col-8">
                    <b-button :id="'popover-reactive-' + data.id" variant="primary" ref="button">
                      Unduh Dokumen
                    </b-button>
                    <b-popover :target="'popover-reactive-' + data.id" triggers="hover"
                      :show.sync="popoverShow[data.id]" placement="auto" container="my-container" ref="popover">
                      <template #title>
                        <b-button @click="onClose(data.id)" class="close" aria-label="Close">
                          <span class="d-inline-block" aria-hidden="true">&times;</span>
                        </b-button>
                        Unduh Dokumen
                      </template>
                      <div v-if="
                        data.filename_final_undangan != null ||
                        data.file_persetujuan != null
                      ">
                        <b-list-group>
                          <b-list-group-item button class="text-success" v-if="data.file_tagihan_iii != null">
                            <a :href="data.file_tagihan_iii" target="_blank">
                              <i class="fa fa-cloud-download"></i> Tagihan</a></b-list-group-item>
                          <b-list-group-item button class="text-success" v-else-if="
                            data.file_tagihan_ii != null &&
                            data.file_tagihan_i != null
                          ">
                            <a :href="data.file_tagihan_ii" target="_blank">
                              <i class="fa fa-cloud-download"></i> Tagihan</a></b-list-group-item>
                          <b-list-group-item button class="text-success" v-else-if="data.file_tagihan_i != null">
                            <a :href="data.file_tagihan_i" target="_blank">
                              <i class="fa fa-cloud-download"></i> Tagihan</a></b-list-group-item>

                          <b-list-group-item button class="text-success" v-if="data.bukti_pembayaran != null">
                            <a :href="data.bukti_pembayaran" target="_blank"><i class="fa fa-cloud-download"></i> Bukti
                              Pembayaran</a>
                          </b-list-group-item>
                          <b-list-group-item button class="text-success" v-if="data.filename_final_undangan != null"><a
                              :href="data.filename_final_undangan" target="_blank">
                              <i class="fa fa-cloud-download"></i> Undangan</a></b-list-group-item>
                          <b-list-group-item button class="text-success" v-if="data.file_izin_ttd != null">
                            <a :href="data.file_izin_ttd" target="_blank">
                              <i class="fa fa-cloud-download"></i> Surat
                              Persetujuan</a></b-list-group-item>
                        </b-list-group>
                      </div>
                      <div v-else>
                        <span>Tidak ada file untuk diunduh</span>
                      </div>
                    </b-popover>
                  </div>
                  <!-- <b-form-select style="width: 150px;margin-right: 20px;" v-model="data.selectedFile"
                    :options="optionsFile"></b-form-select> -->

                  <div class="col-4 mt-2">
                    <span v-if="
                      data.file_tagihan_iii != null &&
                      data.selectedFile == 'tagihan'
                    ">
                      <a :href="data.file_tagihan_iii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                          style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file tagihan" /></a>
                    </span>
                    <span v-else-if="
                      data.file_tagihan_ii != null &&
                      data.file_tagihan_i != null &&
                      data.selectedFile == 'tagihan'
                    ">
                      <a :href="data.file_tagihan_ii" target="_blank"><i class="fa fa-download" aria-hidden="true"
                          style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file tagihan" />
                      </a>
                    </span>
                    <span v-else-if="
                      data.file_tagihan_i != null &&
                      data.selectedFile == 'tagihan'
                    ">
                      <a :href="data.file_tagihan_i" target="_blank"><i class="fa fa-download" aria-hidden="true"
                          style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file tagihan" /></a>
                    </span>

                    <!-- <br> -->
                    <span v-if="
                      data.bukti_pembayaran != null &&
                      data.selectedFile == 'pembayaran'
                    ">
                      <a :href="data.bukti_pembayaran" target="_blank"><i class="fa fa-download" aria-hidden="true"
                          style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file bukti pembayaran" />
                      </a>
                    </span>

                    <span v-if="
                      data.filename_final_surat_tugas != null &&
                      data.selectedFile == 'surattugas'
                    ">
                      <a :href="data.filename_final_surat_tugas" target="_blank"><i class="fa fa-download"
                          aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file surat tugas" /></a>
                    </span>
                    <span v-else-if="
                      data.filename_konsep_surat_tugas != null &&
                      data.selectedFile == 'surattugas'
                    ">
                      <a :href="data.filename_konsep_surat_tugas" target="_blank"><i class="fa fa-download"
                          aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file surat tugas" /></a>
                    </span>

                    <span v-if="
                      data.filename_final_undangan != null &&
                      data.selectedFile == 'undangan'
                    ">
                      <a :href="data.filename_final_undangan" target="_blank"><i class="fa fa-download"
                          aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file undangan" /></a>
                    </span>
                    <span v-else-if="
                      data.filename_konsep_undangan != null &&
                      data.selectedFile == 'undangan'
                    ">
                      <a :href="data.filename_konsep_undangan" target="_blank"><i class="fa fa-download"
                          aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file undangan" /></a>
                    </span>

                    <span v-if="
                      data.file_ba_vertek != null && data.selectedFile == 'ba'
                    ">
                      <a :href="data.file_ba_vertek" target="_blank"><i class="fa fa-download" aria-hidden="true"
                          style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file berita acara" /></a>
                    </span>

                    <span v-if="
                      data.file_final_memorandum != null &&
                      data.selectedFile == 'memo'
                    ">
                      <a :href="data.file_final_memorandum" target="_blank"><i class="fa fa-download" aria-hidden="true"
                          style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file memo" /></a>
                    </span>
                    <span v-else-if="
                      data.file_konsep_memorandum != null &&
                      data.selectedFile == 'memo'
                    ">
                      <a :href="data.file_konsep_memorandum" target="_blank"><i class="fa fa-download"
                          aria-hidden="true" style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file memo" /></a>
                    </span>

                    <span v-if="
                      data.file_persetujuan != null &&
                      data.selectedFile == 'persetujuan'
                    ">
                      <a :href="data.file_persetujuan" target="_blank"><i class="fa fa-download" aria-hidden="true"
                          style="font-size: 20px" data-toggle="tooltip" data-placement="top"
                          title="Unduh file persetujuan" />
                      </a>
                    </span>
                  </div>
                </div>
              </td>
              <td>
                <div style="min-width: 175px">
                  <div class="d-flex align-items-center" style="gap: 6px;">
                    <!-- Button Tracking -->
                    <b-button variant="light" size="sm"
                      class="rounded-pill text-success font-weight-bold shadow-sm border-0 px-3 py-1 d-inline-flex align-items-center"
                      @click="loadProgress(data.id)">
                      <i class="fa fa-search mr-2"></i>
                      <span>Tracking</span>
                    </b-button>

                    <!-- Button Detail -->
                    <b-button variant="light" size="sm"
                      class="rounded-pill text-primary font-weight-bold shadow-sm border-0 px-3 py-1 d-inline-flex align-items-center"
                      @click="edit(data.id)">
                      <i class="fa fa-edit mr-2"></i>
                      <span>Detail</span>
                    </b-button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Widget>

    <ModalTracking v-model="showModalTracking" :progressPermohonan="progressPermohonan" />
  </div>
</template>

<style>
table.table.b-table>thead>tr>th[aria-sort='ascending']::after,
table.table.b-table>tfoot>tr>th[aria-sort='ascending']::after {
  opacity: 1;
  content: '\2191';
}

.dt-button.btn.btn-primary {
  border: none;
}

.dt-button.btn.btn-primary:hover {
  background-color: #35a0fd !important;
  border: none;
}
</style>

<script>
import Widget from '@/components/Widget/Widget'
import Swal from 'sweetalert2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import axios from 'axios'
import VueLoading from 'vuejs-loading-plugin'
import Vue from 'vue'
import moment from 'moment'
import { formatDate } from '../../helper/helpernew'
import ModalTracking from '../Perizinan/Components/ModalTracking.vue'

// using default options
Vue.use(VueLoading)

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Loading', // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: 'rgb(255,255,255)', // set custom background
  classes: ['myclass'], // array, object or string
})

export default {
  name: 'Dynamic',
  components: { Widget, ClassicEditor, vSelect, ModalTracking },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      dataPermohonan: [],
      progressPermohonan: [],
      popoverShow: {},
      showModalTracking: false
    }
  },

  mounted() {
    this.loaddata()
  },
  methods: {
    onClose(id) {
      this.popoverShow[id] = false
    },

    format_date(val, format) {

      if (val) return moment(String(val)).format(format);
    },
    loaddata() {
      axios
        .get(
          this.baseapi +
          'api/permohonan?filter=npwp_pemohon,=,' + this.user.npwp,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataPermohonan = response.data.data
          //console.log(this.dataPermohonan)
          this.initDatatable()
        })
        .catch((error) => {
          //console.log(error)
          return error
        })
    },
    async deletePermohonan(id) {
      Swal.fire({
        title: 'Apa kamu yakin?',
        text: 'Anda tidak akan dapat mengembalikan data ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Tutup',
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + 'api/permohonan/' + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire('Berhasil', '' + response.data.message + '', 'success')
              $('#example').DataTable().destroy()
              this.loaddata()
            })
            .catch((error) => {
              //console.log(error)
            })
        }
      })
    },
    edit(id) {
      localStorage.setItem('id_permohonan', id)
      localStorage.setItem('tipe_pemohon', 'Berusaha')
      this.$router.push('/app/permohonan/form-berusaha')
    },

    loadProgress(id) {
      axios
        .get(
          this.baseapi +
          'api/status_permohonan?filter=id_permohonan,=,' +
          id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data)
          this.progressPermohonan = response.data.data
          this.showModalTracking = true
          // this.$bvModal.show('modal-tracking')
        })
        .catch((error) => {
          //console.log(error)
          return error
        })
    },
    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment('DD MMM YYYY');
        var t = $('#example').DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },

          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            //debugger;
            var index = iDisplayIndexFull + 1
            $('td:first', nRow).html(index)

            if (aData[6] === 'Perbaikan Persyaratan' || aData[6] === 'Penolakan') {
              $(nRow).removeClass('row-setujui').addClass('row-tolak');
            } else if (aData[6] === 'Terbit') {
              $(nRow).removeClass('row-tolak').addClass('row-setujui');
            } else {
              $(nRow).removeClass('row-tolak row-setujui');
            }

            return nRow
          },
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // //console.log(meta.row);
                // //console.log(type == 'export' ? meta.row : data);
                return type == 'export' ? meta.row + 1 : data
              },
              rowCallback: function (row, data, index) {
                //console.log(data)
                if (data[0] == 'OK') {
                  $(row).addClass('green')
                } else if (data[0] == 'Before') {
                  $(row).addClass('orange')
                }
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            // {
            //   text: '<i class="fa fa-plus"></i> Tambah',
            //   className: 'btn btn-primary',
            //   action: function (e, dt, node, config) {
            //     localStorage.removeItem('id_permohonan')
            //     localStorage.setItem('tipe_pemohon', 'Berusaha')
            //     window.location = '/app/permohonan/form-berusaha'
            //   },
            // },
            {
              extend: 'excelHtml5',
              title: 'DATA PEMOHON',
              text: '<i class="fa fa-file-text-o"></i> Excel',
              className: 'btn text-white btn-success',
              exportOptions: {
                columns: [1, 2, 3, 4, 5],
                orthogonal: 'export',
              },
              filename: function () {
                var today = new Date()
                // var n = d.getTime();
                var date =
                  today.getFullYear() +
                  '-' +
                  (today.getMonth() + 1) +
                  '-' +
                  today.getDate()

                return 'Data Pemohon Berusaha ' + date
              },
            },
          ],
        })

        t.on('order.dt search.dt', function () {
          t.column(0, { search: 'applied', order: 'applied' })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1
            })
        }).draw()
      }, 300)
    },
  },
}
</script>

<style src="./Elements.scss" lang="scss" />